<template>
  <div class="video" :class="{ 'video--dark': darkMode }">
    <div class="columns is-desktop">
      <div
        class="column is-7-fullhd is-8-desktop is-10-tablet is-offset-0-widescreen is-offset-1-fullhd is-offset-0-desktop is-offset-1-tablet"
      >
        <video-card
          :video="video"
          :dark="darkMode"
          @switch-dark-mode="switchDarkMode"
        />
      </div>
      <div
        class="column is-3-fullhd is-4-desktop is-offset-0-desktop is-10-tablet is-offset-1-tablet"
      >
        <video-suggestions
          :suggestions="suggestions"
          :dark="darkMode"
          @click-item="goToVideo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { SWITCH_DARK_MODE } from ":mutations";
import { FETCH_VIDEO, FETCH_VIDEO_SUGGESTIONS } from ":actions";

import VideoCard from "%components/video/VideoCard";
import VideoSuggestions from "%components/video/VideoSuggestions";

export default {
  name: "video-view",

  components: {
    VideoCard,
    VideoSuggestions
  },

  props: {
    videoId: Number
  },

  computed: mapState({
    video: state => state.video.video,
    suggestions: state => state.video.suggestions,
    darkMode: state => state.videos.darkMode
  }),

  methods: {
    switchDarkMode(darkMode) {
      this.$store.commit(SWITCH_DARK_MODE, { darkMode });
    },

    async goToVideo(video) {
      await this.$router.push({
        name: "video",
        params: {
          videoId: video.id
        }
      });
      this.$immediatelyScrollToTop();
    },

    fetchVideo() {
      this.$store.dispatch(FETCH_VIDEO, { id: this.videoId });
    },

    fetchVideoSuggestions(video) {
      this.$store.dispatch(FETCH_VIDEO_SUGGESTIONS, { video });
    }
  },

  beforeMount() {
    this.fetchVideo();
  },

  watch: {
    videoId() {
      this.fetchVideo();
    },

    video(video) {
      this.fetchVideoSuggestions(video);
    }
  }
};
</script>

<style lang="scss" scoped>
.video {
  background: url(../assets/img/bubbles.svg) no-repeat center / cover,
    linear-gradient(10deg, $info, $primary, $primary2);
  padding: 5rem 0;

  @include tablet {
    padding: 5rem 1.5rem;
  }

  &--dark {
    background: url(../assets/img/bubbles-dark.svg) no-repeat center / cover,
      $black-bis;
  }
}
</style>
